/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./updateDraft.defs.js";
export { main as default } from "./updateDraft.defs.js";
